export const BANK_ACCOUNTS_RESET_STATE = 'BANK_ACCOUNTS_RESET_STATE';
export const BANK_ACCOUNTS_CURRENT_ITEM = 'BANK_ACCOUNTS_CURRENT_ITEM';

export const BANK_ACCOUNTS_REQUEST_LOADING = 'BANK_ACCOUNTS_REQUEST_LOADING';
export const BANK_ACCOUNTS_REQUEST_SUCCESS = 'BANK_ACCOUNTS_REQUEST_SUCCESS';
export const BANK_ACCOUNTS_REQUEST_FAILED = 'BANK_ACCOUNTS_REQUEST_FAILED';

export const BANK_ACCOUNTS_CURRENT_ACTION = 'BANK_ACCOUNTS_CURRENT_ACTION';
export const BANK_ACCOUNTS_RESET_ACTION = 'BANK_ACCOUNTS_RESET_ACTION';